import React, { Component } from 'react';
import { MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import SelectSearch from 'react-select-search';
import DataLayer from '../../Utilities/DataLayer';

export default class LeadCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            flipped: false,
            reassign: false,
            reassignTo: 0,
            hideCloseButton: (props.hideCloseButton == null) ? false : props.hideCloseButton
        }
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.dataLayer = new DataLayer();

        this.reassignLead = this.reassignLead.bind(this);
        this.closeLead = this.closeLead.bind(this);
    }

    async componentWillReceiveProps() {

    }

    async reassignLead(lead) {
        this.props.loaderOn();
        lead.sfId = this.state.reassignTo;
        await this.dataLayer.Put('/lead/reassignlead', lead);
        this.props.loaderOff();
        this.props.loadLeads(false);
        this.setState({ reassign: false });
    }

    async closeLead(customerLeadId) {
        this.props.loaderOn();
        await this.dataLayer.Put('/lead/closecustomerlead', customerLeadId);
        this.props.loaderOff();
        this.props.loadLeads(false);
    }

    render() {
        return (
            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                <MDBCardText>
                    Assigned To: {this.props.lead.assignedTo}
                </MDBCardText>
                <hr />
                <MDBCardText>
                    <p><MDBIcon icon="user" />&nbsp;&nbsp;<strong>{this.props.lead.customerFirstName}&nbsp;{this.props.lead.customerSurname}</strong></p>
                    <p><MDBIcon icon="phone" />&nbsp;&nbsp;{this.props.lead.customerContactNumber}</p>
                    <p><MDBIcon icon="envelope" />&nbsp;&nbsp;{this.props.lead.customerEmail}</p>
                    <p><MDBIcon icon="calendar-alt" />&nbsp;&nbsp;{this.props.lead.leadDate}</p>
                    {
                        (this.props.lead.sfId == this.props.lead.teamLeaderId) ? (
                            <MDBRow>
                                <MDBCol>
                                    <SelectSearch
                                        options={this.props.managerList}
                                        placeholder="Reassign To..."
                                        value={this.state.reassignTo}
                                        onChange={(selectedItem) => {
                                            this.setState({
                                                reassignTo: selectedItem.value,
                                                reassign: true
                                            });
                                        }}
                                    />
                                </MDBCol>
                            </MDBRow>
                        ) : (<div></div>)
                    }

                    {
                        (this.state.reassign) ? (
                            <MDBRow>
                                <MDBCol>
                                    <MDBBtn className="btn-block" color="pink" onClick={() => this.reassignLead(this.props.lead)}>Reassign</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        ) : (<div></div>)
                    }
                </MDBCardText>
                <hr />
                {
                    (this.state.hideCloseButton) ?
                        (
                            <div></div>
                        ) : (
                            <div className="flex-row text-center">
                                <MDBBtn tag="a" color="red" floating onClick={() => this.closeLead(this.props.lead.customerLeadId)}>
                                    <MDBIcon icon="times" />
                                </MDBBtn>
                            </div >
                        )
                }

            </MDBCard>
        )
    }
}